import React, {ReactElement} from 'react';
import {DeviceType} from '../../../../incase-domain/common/DeviceType.enum';
import {IQuestionElementProps} from '../../../../incase-domain/elements/base/questionElementBase';
import {IElementSequenceQuestion} from '../../../../incase-domain/elements/question/questionSequence';
import {getAnswerStyles} from '../common/getStyles';
import QuestionLayout from '../common/QuestionLayout';
import QuestionAnswer, {AnswerTypes} from '../question/QuestionAnswer';

function SequenceQuestionElement(props: IQuestionElementProps<IElementSequenceQuestion>): ReactElement {
    const {element, device = DeviceType.DESKTOP} = props;
    const {sequence} = element;

    return (
        <QuestionLayout element={element} device={device} showConfirmButton>
            <div className="c-sequenceQuestionElement">
                <div className="c-sequenceQuestionElement__answers">
                    {sequence &&
                        sequence.map((answer, index) => (
                            <QuestionAnswer
                                key={`question-answer-${element.id}-${index}`}
                                answer={answer.text}
                                answerType={AnswerTypes.NONE}
                                comment={answer.comment}
                                leadingIcon="akar-icons:drag-vertical"
                                correctColor={element.correctColor}
                                incorrectColor={element.incorrectColor}
                                debatableColor={element.debatableColor}
                                styles={getAnswerStyles(device, element)}
                                onClick={() => undefined}
                            />
                        ))}
                </div>
            </div>
        </QuestionLayout>
    );
}

export default SequenceQuestionElement;
